import { AutogenModelEdiMovementOrderIc, AutogenRowEdiMovementOrderIc } from "./autogen/AutogenModelEdiMovementOrderIc";

export class ModelEdiMovementOrderIc extends AutogenModelEdiMovementOrderIc<RowEdiMovementOrderIc> {
	constructor() {
		super(RowEdiMovementOrderIc);
	}
}

export class RowEdiMovementOrderIc extends AutogenRowEdiMovementOrderIc {
}